import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'
import { Type } from 'class-transformer'
import TArticleDM from './TArticleDM'

export default class TArticleSuccessorDM extends Data {
	public static className = 'TArticleSuccessorDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	ValidTo?: Date
	RID?: number
	RecordMod?: number
	RecordES?: number
	RecordID?: number
	RecordState?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	ArticleSelfBindCalc?: number
	@Type(() => TArticleDM)
	SuccessorId?: TArticleDM
	@Type(() => TArticleDM)
	ArticleId?: TArticleDM
}